//  _        _      _         _
// | |  _  _| |_  _| |__ _  _| |__ _  _
// | |_| || | | || | '_ \ || | '_ \ || |
// |____\_,_|_|\_,_|_.__/\_,_|_.__/\_,_|
//
// Copyright © Lulububu Software GmbH - All Rights Reserved
// https://lulububu.de
//
// Unauthorized copying of this file, via any medium is strictly prohibited!
// Proprietary and confidential.

import { put } from 'redux-saga/effects';

import SagaStateHelper    from '@helper/SagaStateHelper';
import { LoadingActions } from '@slices/loading';

function* overlayClicked() {
    const clickCount = yield SagaStateHelper.selectFromState('loading', 'clickCount');

    if (clickCount > 10) {
        yield put(LoadingActions.resetOverlay());
    }
}

function* rehydrate() {
    yield put(LoadingActions.rehydrate());
}

function* resetClickCount() {
    yield put(LoadingActions.resetClickCount());
}

export default {
    overlayClicked,
    rehydrate,
    resetClickCount,
};
